<template>
    <div
        class="container-fluid weflix-admin-collections page-card edit-collections-page"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <header class="edit-collections-header">
            <div class="edit-collections-header__lead">
                <TitlePage
                    title="Minhas Coleções"
                    subtitle="Gerencie suas coleções ou crie novas. Arraste-as para mudar a ordem de visualização no portal."
                    :hasMargin="false"
                />
            </div>
            <div class="edit-collections-header__actions">
                <div
                    class="searchContainer searchCollectionsMobile edit-collections-search d-none d-md-flex"
                    :class="{ open: isSearchOpen }"
                >
                    <div class="form-group" :class="{ visible: isSearchOpen }">
                        <div class="form-input">
                            <input
                                type="text"
                                class="inputd"
                                placeholder="Pesquisar coleção..."
                                v-model="searchText"
                                @input="handleSearch"
                            />
                        </div>
                    </div>
                    <v-btn
                        variant="outlined"
                        color="primary"
                        @click="toggleSearch"
                        height="40"
                        icon
                        rounded="lg"
                        border="2"
                        class="edit-collections-icon-btn"
                    >
                        <fa icon="fa-search" />
                    </v-btn>
                </div>
                <v-btn
                    variant="flat"
                    color="primary"
                    rounded="lg"
                    title="Criar nova coleção"
                    :icon="$vuetify.display.xs"
                    class="text-none edit-collections-new-btn"
                    @click="() => $router.push('/admin/nova-colecao')"
                >
                    <template v-if="$vuetify.display.xs">
                        <v-icon>mdi-plus</v-icon>
                    </template>
                    <template v-else>
                        <v-icon class="me-1" size="small">mdi-plus</v-icon>
                        Nova coleção
                    </template>
                </v-btn>
            </div>
        </header>

        <div
            class="searchContainer searchCollectionsMobile edit-collections-search-mobile d-md-none w-100"
            :class="{ open: isSearchOpen }"
        >
            <div
                class="form-group flex-grow-1"
                :class="{ visible: isSearchOpen }"
            >
                <div class="form-input">
                    <input
                        type="text"
                        class="inputd"
                        placeholder="Pesquisar coleção..."
                        v-model="searchText"
                        @input="handleSearch"
                    />
                </div>
            </div>
            <v-btn
                variant="outlined"
                color="primary"
                @click="toggleSearch"
                height="40"
                icon
                rounded="lg"
                border="2"
                class="edit-collections-icon-btn"
            >
                <fa icon="fa-search" />
            </v-btn>
        </div>

        <div
            class="edit-collections-shell"
            ref="scrollContainer"
            @scroll.passive="handleScroll"
        >
            <section class="edit-collections-stats" aria-label="Resumo">
                <article
                    class="edit-collections-stat-card"
                    data-aos="fade-down"
                    data-aos-duration="1500"
                >
                    <div class="edit-collections-stat-card__icon" aria-hidden="true">
                        <fa icon="fa-film" />
                    </div>
                    <div class="edit-collections-stat-card__body">
                        <span class="edit-collections-stat-card__label">Coleções</span>
                        <strong class="edit-collections-stat-card__value">{{
                            panelData?.collections ?? 0
                        }}</strong>
                    </div>
                </article>
                <article
                    class="edit-collections-stat-card"
                    data-aos="fade-down"
                    data-aos-duration="1500"
                >
                    <div class="edit-collections-stat-card__icon" aria-hidden="true">
                        <fa icon="fa-circle-play" />
                    </div>
                    <div class="edit-collections-stat-card__body">
                        <span class="edit-collections-stat-card__label">Vídeos</span>
                        <strong class="edit-collections-stat-card__value">{{
                            panelData?.videos ?? 0
                        }}</strong>
                    </div>
                </article>
                <article
                    class="edit-collections-stat-card"
                    data-aos="fade-down"
                    data-aos-duration="1500"
                >
                    <div class="edit-collections-stat-card__icon" aria-hidden="true">
                        <fa icon="fa-clock-rotate-left" />
                    </div>
                    <div class="edit-collections-stat-card__body">
                        <span class="edit-collections-stat-card__label">Tempo total</span>
                        <strong class="edit-collections-stat-card__value"
                            >{{ panelData?.videoTimeUsed ?? 0 }}h</strong
                        >
                    </div>
                </article>
            </section>

            <div class="edit-collections-list-panel">
        <div class="choose-view-mode edit-collections-view-meta">
            <div class="info-view-mode-videos-exibidos">
                <span>
                    Exibindo {{ currentVideosLength * indexIteration }} /
                    {{
                        filteredCollections.reduce(
                            (acc, c) => acc + (c.totalVideos || 0),
                            0
                        )
                    }}
                    vídeos
                </span>
            </div>
            <div class="viewOptionsContainer" v-if="false">
                <button
                    class="btnViewOption"
                    :class="{ active: view === 3 }"
                    @click="changeView(3)"
                    title="Visualização em cards"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        style="fill: gray; width: 20px"
                        viewBox="0 0 448 512"
                    >
                        <path
                            d="M128 96A64 64 0 1 1 0 96a64 64 0 1 1 128 0zm0 160A64 64 0 1 1 0 256a64 64 0 1 1 128 0zM64 480a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM288 96A64 64 0 1 1 160 96a64 64 0 1 1 128 0zM224 320a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm64 96a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm96-256a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm64 96a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zM384 480a64 64 0 1 1 0-128 64 64 0 1 1 0 128z"
                        />
                    </svg>
                </button>
                <button
                    class="btnViewOption"
                    :class="{ active: view === 1 }"
                    @click="changeView(1)"
                    title="Visualização em blocos"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        style="fill: gray; width: 30px"
                        viewBox="0 0 448 512"
                    >
                        <path
                            d="M128 168c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zm0 160c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zm32-160l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM288 328c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zm32-160l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM448 328c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48z"
                        />
                    </svg>
                </button>
                <button
                    class="btnViewOption"
                    :class="{ active: view === 2 }"
                    @click="changeView(2)"
                    title="Visualização em lista"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        style="fill: gray; width: 24px"
                        viewBox="0 0 512 512"
                    >
                        <path
                            d="M40 48C26.7 48 16 58.7 16 72l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L40 48zM184 72c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L184 72zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0zM16 232l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z"
                        />
                    </svg>
                </button>
            </div>
        </div>
        <draggable
            :list="visibleCollections"
            :disabled="isMobile"
            class="list-group"
            :class="{ grid: view === 1, list: view === 2, cards: view === 3 }"
            ghost-class="ghost"
            :move="checkMove"
            @start="dragging = true"
            @end="onDragEnd"
        >
            <template #item="{ element, index }">
                <div class="list-group-item" :id="`collection-${element.id}`">
                    <div
                        class="item"
                        :class="{
                            wide:
                                !element.imageFinalPath2 ||
                                element.imageFinalPath2 ===
                                    'https://image.weeduc.com/',
                        }"
                        @click="goToCollection(element.id, element)"
                    >
                        <div class="drag-handle" v-if="dragging">
                            <fa icon="fa-grip-vertical" />
                        </div>
                        <div
                            v-if="view == 3"
                            class="backgroundItemCollection"
                            :class="{
                                wide:
                                    !element.imageFinalPath2 ||
                                    element.imageFinalPath2 ===
                                        'https://image.weeduc.com/',
                            }"
                            :style="{
                                backgroundImage:
                                    element.imageFinalPath2 &&
                                    element.imageFinalPath2 !==
                                        'https://image.weeduc.com/'
                                        ? cssBackgroundUrl(element.imageFinalPath2)
                                        : element.imageFinalPath
                                          ? cssBackgroundUrl(element.imageFinalPath)
                                          : cssBackgroundUrl(
                                                require('@/assets/Weflix/default-video-thumbnail.jpg')
                                            ),
                            }"
                        >
                            <span
                                class="status-badge"
                                :class="
                                    element.status == '1'
                                        ? 'enabled'
                                        : 'disabled'
                                "
                            >
                                {{
                                    element.status == '1'
                                        ? 'Habilitado'
                                        : 'Desabilitado'
                                }}
                            </span>
                            <fa
                                v-if="index < 6"
                                icon="fa-star"
                                class="collection-card-star"
                            />
                        </div>
                        <div
                            v-else
                            class="backgroundItemCollection"
                            :class="{ noImage: !element.imageFinalPath }"
                            :style="{
                                backgroundImage: element.imageFinalPath
                                    ? cssBackgroundUrl(element.imageFinalPath)
                                    : cssBackgroundUrl(
                                          require('@/assets/Weflix/default-video-thumbnail.jpg')
                                      ),
                            }"
                        >
                            <span
                                class="status-badge"
                                :class="
                                    element.status == '1'
                                        ? 'enabled'
                                        : 'disabled'
                                "
                            >
                                {{
                                    element.status == '1'
                                        ? 'Habilitado'
                                        : 'Desabilitado'
                                }}
                            </span>
                            <fa
                                v-if="index < 6"
                                icon="fa-star"
                                class="collection-card-star"
                            />
                        </div>
                        <div
                            class="itemContent"
                            :class="{ noImage: !element.imageFinalPath }"
                        >
                            <div class="titleItemCollection">
                                {{ element.comercialName }}
                            </div>
                            <div class="descriptionItemCollectionText">
                                <p>{{ descriptionPreviewText(element) }}</p>
                            </div>
                            <div
                                class="descriptionItemCollection admin-collections"
                            >
                                <p>
                                    <fa
                                        icon="fa-tv"
                                        style="width: 22px !important"
                                    />
                                    {{ element.totalVideos }} vídeos
                                </p>
                                <p>
                                    <fa
                                        icon="fa-clock"
                                        style="width: auto !important"
                                    />
                                    {{ converterTempo(element.totalTime) }}
                                </p>
                            </div>
                            <div
                                class="descriptionItemCollectionVideo"
                                v-if="view != 3"
                            >
                                {{
                                    element?.shortDescription?.replace(
                                        /<[^>]*>/g,
                                        ''
                                    )
                                }}
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </draggable>
        <div v-if="loadingMore" class="edit-collections-loading">
            <fa icon="fa-spinner" spin /> Carregando mais coleções...
        </div>

        <div
            v-if="visibleCollections.length === 0 && hasReady && !loadingMore"
            class="edit-collections-empty"
        >
            Nenhuma coleção encontrada.
        </div>
            </div>
        </div>
    </div>
    <Loader :hasReady="hasReady" />
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import apiCollections from '@/utils/Weflix/collections';
    import Loader from '@/components/Weflix/Loader';
    import draggable from 'vuedraggable';
    import TitlePage from '@/components/Weflix/titlePage.vue';

    let id = 1;

    export default {
        data() {
            return {
                collections: [],
                hasReady: false,
                dragging: false,
                showCollections: false,
                isMobileIcon: false,
                isMobile: false,
                searchText: '',
                view: 3,
                isSearchOpen: false,
                itemsToShow: 12,
                loadingMore: false,
                scrollListener: null,
                currentVideosLength: 12,
                indexIteration: 1,
            };
        },
        mounted() {
            this.checkScreenSize();
            window.addEventListener('resize', this.checkScreenSize);
            this.isMobile = window.innerWidth <= 600;

            // Attach scroll event to container
            this.$nextTick(() => {
                if (this.$refs.scrollContainer) {
                    this.$refs.scrollContainer.addEventListener(
                        'scroll',
                        this.handleScroll,
                        { passive: true }
                    );
                }
            });
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.checkScreenSize);
            if (this.$refs.scrollContainer) {
                this.$refs.scrollContainer.removeEventListener(
                    'scroll',
                    this.handleScroll
                );
            }
        },
        computed: {
            ...mapState(['token', 'panelData']),
            filteredCollections() {
                if (!this.searchText || this.searchText.length < 3) {
                    return this.collections;
                }
                const searchLower = this.searchText.toLowerCase();
                return this.collections.filter((collection) =>
                    collection.comercialName.toLowerCase().includes(searchLower)
                );
            },
            visibleCollections() {
                // Exibe apenas os primeiros itemsToShow da lista filtrada
                return this.filteredCollections.slice(0, this.itemsToShow);
            },
            hasMore() {
                return this.itemsToShow < this.filteredCollections.length;
            },
        },
        methods: {
            ...mapActions(['storeCurrentCollections', 'storeToken']),

            toggleSearch() {
                this.isSearchOpen = !this.isSearchOpen;
                if (!this.isSearchOpen) {
                    this.searchText = '';
                }
            },

            /** URLs com () ou espaços em backgroundImage precisam de url("...") — senão o CSS fica inválido. */
            cssBackgroundUrl(href) {
                if (href == null || href === '') return 'none';
                const s = String(href);
                const escaped = s.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
                return `url("${escaped}")`;
            },
            stripHtmlDescription(raw) {
                if (raw == null || raw === '') return '';
                return String(raw)
                    .replace(/<[^>]*>/g, '')
                    .replace(/\s+/g, ' ')
                    .trim();
            },
            descriptionPreviewText(element) {
                const t = this.stripHtmlDescription(element?.shortDescription);
                if (this.view === 3) return t;
                const max = this.isMobile ? 50 : 100;
                return t ? `${t.slice(0, max)}...` : '';
            },
            handleSearch() {
                // O filtro agora é feito automaticamente através do computed property filteredCollections
                // Resetar o scroll e quantidade de itens ao pesquisar
                this.itemsToShow = 12;
                this.$nextTick(() => {
                    if (this.$refs.scrollContainer) {
                        this.$refs.scrollContainer.scrollTop = 0;
                    }
                });
            },

            goToCollection(id, collections) {
                this.storeCurrentCollections({
                    currentCollections: collections,
                });
                this.$router.push('/admin/colecao/' + id);
            },
            async getCollections() {
                try {
                    const catalog = await apiCollections.getCollection(
                        this.token
                    );
                    this.collections = [...(catalog.courses || [])].sort((a, b) => {
                        // Garante que order seja um número
                        const orderA = Number(a.order) || 0;
                        const orderB = Number(b.order) || 0;
                        return orderA - orderB;
                    });
                    this.hasReady = true;
                } catch (error) {
                    console.error('Erro ao obter dados das coleções:', error);
                }
            },
            resetToken() {
                this.storeToken({ token: '12345' });
            },
            checkMove: function (e) {},
            onDragEnd: function (e) {
                const movedElement = this.collections[e.newIndex];

                // Filtrar collections para obter apenas order e id
                const collectionOrderAndId = this.collections.map((item) => ({
                    id: item.id,
                    nome: item.comercialName,
                    order: this.collections.indexOf(item) + 1,
                }));
                this.updateCollectionOrder(collectionOrderAndId);
                this.dragging = false;
            },
            async updateCollectionOrder(collectionOrderAndId) {
                try {
                    const response = await apiCollections.updateCollectionOrder(
                        this.token,
                        collectionOrderAndId
                    );
                } catch (error) {
                    console.error('Erro ao atualizar ordem da coleção:', error);
                }
            },
            checkScreenSize() {
                this.isMobileIcon = window.innerWidth <= 600;
                if (window.innerWidth <= 600 && !this.dragging) {
                    this.view = 3;
                }
            },
            converterTempo(segundos) {
                const horas = Math.floor(segundos / 3600).toLocaleString(
                    'pt-BR'
                );
                const minutos = Math.floor((segundos % 3600) / 60);
                const segundosRestantes = segundos % 60;

                let resultado = '';
                if (horas > 0) {
                    resultado += `${horas}h `;
                }
                if (minutos > 0 || horas > 0) {
                    resultado += `${minutos}m `;
                } else {
                    resultado += '0m ';
                }

                return resultado.trim();
            },
            changeView(view) {
                this.view = view;
            },
            handleScroll() {
                // Infinity scroll: carrega mais quando chega perto do fim
                if (this.loadingMore || !this.hasMore) return;
                const container = this.$refs.scrollContainer;
                if (!container) return;
                // Checa se está próximo do fim (100px do fundo)
                if (
                    container.scrollTop + container.clientHeight >=
                    container.scrollHeight - 100
                ) {
                    this.loadMore();
                }
            },
            loadMore() {
                if (this.loadingMore || !this.hasMore) return;
                this.loadingMore = true;
                this.indexIteration++;
                setTimeout(() => {
                    // Adiciona mais 12 itens
                    this.itemsToShow = Math.min(
                        this.itemsToShow + 12,
                        this.filteredCollections.length
                    );
                    this.loadingMore = false;
                }, 500); // Simula um pequeno delay de carregamento
            },
        },
        components: {
            Loader,
            draggable,
            TitlePage,
        },
        watch: {
            searchText() {
                // Resetar a paginação ao pesquisar
                this.itemsToShow = 12;
            },
            filteredCollections() {
                // Se o filtro reduzir a lista, garantir que não tente mostrar mais do que existe
                if (this.itemsToShow > this.filteredCollections.length) {
                    this.itemsToShow = this.filteredCollections.length;
                }
            },
        },
        created() {
            this.getCollections();
        },
    };
</script>

<style scoped>
    @import url(./global.css);

    .edit-collections-page.weflix-admin-collections.page-card {
        background: #f4f5f8;
        border-radius: 16px;
        padding: 0 0 1rem;
        box-shadow: 0 1px 3px rgba(37, 8, 145, 0.06);
    }

    .edit-collections-header {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: space-between;
        gap: 1rem 1.5rem;
        padding: 1.25rem 1.5rem 1rem;
        background: linear-gradient(135deg, #fafbff 0%, #ffffff 100%);
        border-bottom: 1px solid #e8eaf0;
        border-radius: 16px 16px 0 0;
    }

    .edit-collections-header__lead {
        flex: 1;
        min-width: 200px;
    }

    .edit-collections-header__lead :deep(.titlelayoutGeneric) {
        border-bottom: none;
        padding-bottom: 0;
    }

    .edit-collections-header__lead :deep(.titlelayoutGeneric h3) {
        font-size: 1.5rem;
        margin: 0 0 0.35rem;
        color: #1a1d26;
    }

    .edit-collections-header__lead :deep(.titlelayoutGeneric small) {
        display: block;
        color: #5c6370;
        line-height: 1.45;
    }

    .edit-collections-header__actions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 0.75rem;
    }

    .edit-collections-icon-btn {
        flex-shrink: 0;
    }

    .edit-collections-new-btn {
        min-height: 40px;
        font-weight: 600;
    }

    .edit-collections-search-mobile {
        padding: 0.75rem 1.5rem 0;
        gap: 0.5rem;
    }

    /* Área rolável só nesta tela (/admin/colecoes) */
    .edit-collections-page .edit-collections-shell {
        padding: 1.25rem 1.5rem 1.5rem;
        height: calc(100vh - 210px);
        overflow-y: auto;
        min-height: 0;
        box-sizing: border-box;
        scrollbar-width: none;
        -ms-overflow-style: none;
    }

    .edit-collections-page .edit-collections-shell::-webkit-scrollbar {
        display: none;
    }

    .edit-collections-stats {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 1rem;
        margin-bottom: 1.25rem;
    }

    @media (max-width: 767px) {
        .edit-collections-stats {
            grid-template-columns: 1fr;
        }
    }

    .edit-collections-stat-card {
        display: flex;
        align-items: center;
        gap: 1rem;
        padding: 1rem 1.25rem;
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    }

    .edit-collections-stat-card__icon {
        width: 44px;
        height: 44px;
        border-radius: 12px;
        background: #eef0fc;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .edit-collections-stat-card__icon :deep(svg) {
        color: #250891 !important;
        width: 1.25rem !important;
        height: 1.25rem !important;
    }

    .edit-collections-stat-card__body {
        display: flex;
        flex-direction: column;
        gap: 0.15rem;
        min-width: 0;
        text-align: left;
    }

    .edit-collections-stat-card__label {
        font-size: 0.75rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        color: #5c6370;
    }

    .edit-collections-stat-card__value {
        font-size: 1.35rem;
        font-weight: 700;
        color: #1a1d26;
        line-height: 1.2;
    }

    .edit-collections-list-panel {
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        padding: 1rem 1.25rem 1.25rem;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    }

    .edit-collections-view-meta.choose-view-mode {
        margin-bottom: 1rem;
        padding-bottom: 0.75rem;
        border-bottom: 1px solid #f0f2f5;
    }

    .edit-collections-loading {
        text-align: center;
        padding: 1.25rem 0.5rem 0;
        color: #7a8190;
    }

    .edit-collections-empty {
        text-align: center;
        padding: 1rem 0.5rem 0.5rem;
        color: #7a8190;
    }

    .btnNewCollection {
        position: absolute;
        width: auto;
        padding: 6px 12px;
        background-color: #250891;
        color: white;
        border-radius: 5px;
        top: 20px;
        right: 20px;
        cursor: pointer;
    }
    .titleItemCollection {
        color: black;
    }

    .weflix-admin-collections .item {
        display: flex;
        cursor: pointer;
        border: 1px solid #25099130;
        border-radius: 5px;
        padding: 0;
        height: 170px;
        overflow: hidden;
        gap: 20px;
        justify-content: flex-start;
        position: relative;
    }

    .status-badge {
        font-size: 12px;
        padding: 2px 8px;
        border-radius: 12px;
        margin-left: 10px;
        position: absolute;
        top: 10px;
        right: 10px;
    }

    .status-badge.enabled {
        background-color: #4caf50;
        color: white;
    }

    .status-badge.disabled {
        background-color: #f44336;
        color: white;
    }

    .collection-card-star {
        position: absolute;
        top: 10px;
        left: 10px;
        z-index: 1;
        font-size: 20px;
        color: gold;
    }

    /* Card View — altura fixa: capa + título (2 linhas) + descrição (2 linhas) + ícones */
    .list-group.cards {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
    }

    .list-group.cards .list-group-item {
        min-height: 0;
        display: flex;
    }

    .list-group.cards .item {
        flex-direction: column;
        flex: 1;
        min-width: 0;
        min-height: 320px;
        height: 320px;
        max-height: 320px;
        gap: 0;
    }

    .list-group.cards .backgroundItemCollection {
        width: 100%;
        flex: 0 0 168px;
        height: 168px;
        min-height: 168px;
        background-size: cover;
        background-position: center;
    }

    .list-group.cards .itemContent {
        width: 100%;
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
        padding: 10px 12px 12px;
        box-sizing: border-box;
    }

    .list-group.cards .titleItemCollection {
        margin: 0 0 6px;
        padding: 0;
        font-size: 14px;
        font-weight: 700;
        line-height: 1.35;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .list-group.cards .descriptionItemCollectionText {
        flex: 1 1 auto;
        min-height: 0;
        margin: 0 0 8px;
        overflow: hidden;
    }

    .list-group.cards .descriptionItemCollectionText p {
        margin: 0;
        font-size: 12px;
        line-height: 1.45;
        color: #6b6b6b;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .list-group.cards .descriptionItemCollection.admin-collections {
        margin-top: auto;
        margin-bottom: 0;
        flex-shrink: 0;
        gap: 10px;
        flex-wrap: wrap;
    }

    .list-group.cards .descriptionItemCollectionVideo {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .item.featured {
        border: 2px solid gold;
        animation: borderFlash 1s infinite;
    }

    @keyframes borderFlash {
        0% {
            border-color: gold;
        }
        50% {
            border-color: #ffd70080;
        }
        100% {
            border-color: gold;
        }
    }
    .drag-handle {
        position: absolute;
        left: 5px;
        top: 50%;
        transform: translateY(-50%);
        color: #250891;
        font-size: 20px;
        z-index: 10;
        background: rgba(255, 255, 255, 0.9);
        padding: 5px;
        border-radius: 4px;
        cursor: move;
    }
    .collecttionsItens {
        padding: 10px;
    }
    .titleItemCollection {
        text-align: left;
        font-size: 20px;
        margin-top: 30px;
        font-weight: 700;
        display: flex;
        align-items: center;
    }
    .descriptionItemCollection {
        margin-top: 10px;
        display: flex;
        gap: 10px;
    }
    .descriptionItemCollection p {
        color: gray;
        margin: 0;
    }
    .descriptionItemCollection.admin-collections svg path {
        fill: #6b6b6b !important;
        stroke-width: 0 !important;
        stroke: #848484 !important;
    }
    .descriptionItemCollection svg {
        font-size: 15px;
    }

    /* BLOCO DE CSS PARA O CONTADOR DE VÍDEOS EXIBIDOS */
    .info-view-mode-videos-exibidos {
        display: flex;
        align-items: center;
        gap: 8px;

        border-radius: 6px;
        padding: 8px 18px;
        font-size: 13px;
        font-weight: 500;
        color: #7d7d7d;

        min-width: 220px;
        width: -moz-fit-content;
    }
    .info-view-mode-videos-exibidos .icon-videos-exibidos {
        color: #250991;
        font-size: 18px;
    }
    @media (max-width: 600px) {
        .descriptionItemCollectionText {
            text-align: left;
            font-size: 12px;
            color: gray;
        }
        .info-view-mode-videos-exibidos {
            font-size: 13px;
            padding: 0;
            min-width: 120px;
            margin: 0;
        }
        .info-view-mode-videos-exibidos .icon-videos-exibidos {
            font-size: 15px;
        }
    }
    html::-webkit-scrollbar {
        display: none;
    }
</style>
<style>
    .itemAtionCollection .form-check-input:checked {
        background-color: #1ac7d0;
        border: 1px solid #1ac7d0;
    }
    .itemAtionCollections .form-check-input {
        margin-right: 1rem !important;
        cursor: pointer;
        flex-shrink: 0;
        width: 3rem;
        height: 1.375rem;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='white'/%3E%3C/svg%3E");
        background-color: #8d8d8d;
        border: 1px solid #8d8d8d;
        box-shadow: none;
    }
    .itemAtionCollections .form-check-input {
        margin-right: 1rem !important;
        cursor: pointer;
        flex-shrink: 0;
        width: 3rem;
        height: 1.375rem;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='white'/%3E%3C/svg%3E");
        background-color: #8d8d8d;
        border: 1px solid #8d8d8d;
        box-shadow: none;
    }
    .collecttionsItens .itemAtionCollections.form-check.form-switch {
        position: absolute;
        top: 10px;
        right: 0;
    }

    .backgroundItemCollection {
        width: 60%;
        background-size: cover;
    }
    .itemContent.noImage {
        padding: 0px 10px;
    }
</style>

<style scoped>
    .buttons {
        margin-top: 35px;
    }

    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }
    .list-group-item {
        border: none;
    }
    .backgroundItemCollection.noImage {
        background-size: contain;
    }

    .form-group {
        max-width: 400px;
        transition: all 0.3s ease;
        overflow: hidden;
        max-height: 0;
    }

    .form-group.visible {
        max-height: 50px;
        margin: 0px 10px;
    }

    .form-input {
        position: relative;
        display: flex;
        align-items: center;
        margin-bottom: 0;
    }

    .form-input input {
        width: 100%;
        padding: 8px 35px 8px 15px;
        border: 1px solid #e8e8e8;
        border-radius: 5px;
        font-size: 14px;
        transform: translateX(-100%);
        opacity: 0;
        transition: all 0.3s ease;
    }

    .form-group.visible .form-input input {
        transform: translateX(0);
        opacity: 1;
        height: 34px;
    }

    .form-input svg {
        position: absolute;
        right: 10px;
        color: #250991;
    }

    .btnSearchCollections {
        background-color: #21212100;
        color: #250891;
        border: 1px solid #250891;
        border-radius: 5px;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        padding: 6px 6px;
        transition: all 500ms ease-in-out;
        z-index: 2;
    }

    .btnSearchCollections svg {
        color: #250991;
    }

    .btnSearchCollections:hover {
        color: white;
        background-color: #1b0668;
    }

    .btnSearchCollections:hover svg {
        color: white;
    }

    .searchContainer {
        display: flex;
        align-items: center;
        width: auto;
        top: 0;
        transition: all 0.3s ease;
    }

    .viewOptionsContainer {
        gap: 10px;
        display: flex;
    }
    button.btnViewOption.active svg {
        color: #b3bced;
    }
    /* List view */
    .list-group.list .backgroundItemCollection {
        display: none;
    }
    .list .list-group-item {
        padding: 5px 10px;
    }
    .list-group.list .item {
        height: 40px;
    }
    .list-group.list .titleItemCollection {
        margin: 10px;
    }

    .list-group.list .titleItemCollection {
        font-size: 14px;
    }
    .list-group.list .descriptionItemCollection p {
        font-size: 13px;
    }
    .list-group.list .descriptionItemCollection p svg {
        font-size: 13px;
    }
    .descriptionItemCollection p {
        color: gray;
        text-align: left;
        font-size: 11px;
    }
    .list-group.list .descriptionItemCollectionVideo {
        display: none;
    }
    .descriptionItemCollectionVideo p {
        text-align: left;
        font-size: 13px;
        margin-top: 10px;
        color: gray;
    }
    .descriptionItemCollectionVideo {
        text-align: left;
        font-size: 13px;
        padding-top: 5px;
    }
    .list-group.cards .list-group-item {
        padding: 8px;
    }
    .list-group.cards .item.featured {
        min-height: 540px;
        height: 540px;
        max-height: 540px;
    }
    .list-group.cards .item.featured .backgroundItemCollection {
        flex: 0 0 288px;
        height: 288px;
        min-height: 288px;
    }
    .list-group.cards .backgroundItemCollection.wide {
        flex: 0 0 132px;
        height: 132px;
        min-height: 132px;
    }
    .list-group.cards .item.wide {
        min-height: 300px;
        height: 300px !important;
        max-height: 300px !important;
    }
    .descriptionItemCollectionText {
        text-align: left;
        font-size: 12px;
        color: gray;
        height: auto;
    }
    .descriptionItemCollectionText p {
        text-align: left;
        font-size: 12px;
        color: gray;
        margin: 0;
    }
    .choose-view-mode {
        display: flex;
        justify-content: space-between;
    }
    button.btnViewOption.active svg {
        fill: rgb(37, 9, 145) !important;
    }
    @media (max-width: 992px) and (min-width: 600px) {
        .list-group.cards {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    @media (max-width: 600px) {
        .list-group.cards .item.featured {
            height: 300px;
        }
        .weflix-admin-collections .btnWeflix {
            padding: 2px;
            margin: 2px;
            height: 35px;
            align-content: center;
        }
        .btnWeflix.absolute svg {
            color: #250891;
        }
        .btnWeflix:hover svg {
            color: white;
        }
        .backgroundItemCollection {
            width: 100%;
            background-size: 100%;
        }
        .item {
            gap: 0px;
            flex-wrap: wrap;
        }
        .list-group.cards .item {
            min-height: 300px;
            height: 300px;
            max-height: 300px;
        }
        .list-group.cards .backgroundItemCollection {
            flex: 0 0 150px;
            height: 150px;
            min-height: 150px;
        }
        .list-group.cards .item.featured {
            min-height: 520px;
            height: 520px;
            max-height: 520px;
        }
        .list-group.cards .item.featured .backgroundItemCollection {
            flex: 0 0 268px;
            height: 268px;
            min-height: 268px;
        }
        .list-group.grid .titleItemCollection {
            margin-top: 10px;
            font-size: 16px !important;
        }
        .edit-collections-stat-card {
            padding: 0.85rem 1rem;
        }
        .edit-collections-stat-card__value {
            font-size: 1.15rem;
        }
        .descriptionItemCollectionVideo {
            display: none;
        }
        .list-group.list .titleItemCollection {
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .list-group.list .descriptionItemCollection {
            display: none;
        }
        .list-group.cards {
            grid-template-columns: 1fr;
        }
        .weflix-admin-collections .titleContainer {
            padding: 0px 0px 10px 10px !important;
        }
        .titleContainer p {
            font-size: 12px;
            margin: 15px 0px;
        }
        .searchContainer.searchCollectionsMobile .form-group {
            margin: 0;
        }

        .btnSearch {
            justify-content: center;
        }
        .searchContainer.searchCollectionsMobile {
            display: flex;
            position: relative;
            gap: 10px;
            top: 0;
            right: 0;
        }
        .weflix-admin-collections .choose-view-mode {
            display: flex;
            padding: 10px;
        }
        .weflix-admin-collections .choose-view-mode .viewOptionsContainer {
            position: relative;
            top: 0;
            right: 0;
        }
        .weflix-admin-collections .form-input {
            padding: 0;
        }
        .weflix-admin-collections .list-group.list .item {
            height: 100%;
        }
        .weflix-admin-collections .list .item.featured {
            border: 1px dashed #250891;
        }
        .weflix-admin-collections h3 {
            font-size: 20px;
            color: #333;
        }
        .weflix-admin-collections .list .itemContent {
            width: 100%;
        }
        .weflix-admin-collections .choose-view-mode span {
            font-size: 13px;
            color: #333;
            font-weight: 400;
            font-family: 'Poppins';
            font-style: normal;
        }
        .weflix-admin-collections .list-group.list .titleItemCollection {
            display: block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 14px;
            font-weight: 600;
        }

    }
</style>

<style>
    .descriptionItemCollection.admin-collections p svg path {
        fill: #6b6b6b !important;
        stroke-width: 0 !important;
        stroke: #848484 !important;
    }
</style>
